import React from 'react'
import { Link } from 'react-router-dom'

const projects = [
  {
    title: 'V4 Design Specialists',
    url: 'https://www.v4designspecialists.com/',
    stack: 'PHP, CodeIgniter, MySQL',
    summary:
      'Delivered a polished, content-driven site for a design consultancy with a strong focus on clear service messaging and dependable publishing workflows. I handled the implementation and backend structure so the team could update pages without constant developer support.',
    impact: 'Improved site clarity and usability for prospective clients across desktop and mobile.',
  },
  {
    title: 'Assure Defi',
    url: 'https://assuredefi.com/',
    stack: 'WordPress, Webflow, Node.js, APIs',
    summary:
      'Built a modern marketing site for a crypto-focused product, combining CMS-driven content with custom integrations for a more reliable launch experience. The work balanced editorial flexibility with strong technical foundations for performance and maintainability.',
    impact: 'Helped create a launch-ready digital presence that supported rapid updates and external integrations without compromising usability.',
  },
  {
    title: 'Lynk Remote Technologies',
    url: 'https://lynkremote.com/',
    stack: 'IoT, AWS, React, Node.js',
    summary:
      'Contributed to an IoT platform that connected devices, cloud services, and customer-facing dashboards in one workflow. I helped build the web and backend layers for data flows, device operations, and internal tooling used across the product.',
    impact: 'Improved operational visibility for connected devices and reduced friction between field operations, product teams, and customer support.',
  },
  {
    title: 'Anime Listing Demo',
    url: 'https://anime.harjeevan.ca/',
    stack: 'React, REST APIs, UI Design',
    summary:
      'Created a responsive React demo app focused on browsing and exploring anime content through a clean, animated interface. The project was a practical exercise in component architecture, API integration, and polished user experience.',
    impact: 'Showcased a fast, accessible interface and demonstrated how thoughtful UI choices can make data-heavy experiences feel more approachable.',
  },
]

function Projects() {
  return (
    <section className="ftco-section ftco-project" id="projects-section">
      <div className="container">
        <div className="row justify-content-center pb-5">
          <div className="col-md-12 heading-section text-center ">
            <h1 className="big big-2">Projects</h1>
            <h2 className="mb-4">Featured Projects</h2>
            <p>
              Selected work spanning product websites, cloud-connected platforms, and React-based interfaces.
            </p>
          </div>
        </div>

        <div className="row">
          {projects.map((project) => (
            <div className="col-md-6 mb-4" key={project.title}>
              <div
                className="p-4 h-100"
                style={{
                  background: 'rgba(255, 255, 255, 0.04)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: '14px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
                  backdropFilter: 'blur(8px)',
                }}
              >
                <h3 className="mb-2">
                  <Link to={project.url} target="_blank" rel="noopener noreferrer">
                    {project.title}
                  </Link>
                </h3>
                <p className="text-muted mb-3" style={{ fontSize: '0.95rem' }}>
                  {project.stack}
                </p>
                <p className="mb-2">{project.summary}</p>
                <p className="mb-0"><strong>Outcome:</strong> {project.impact}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Projects